import { useEffect, useState } from 'react';

interface Plan {
  id: string;
  name: string;
  token_quota: number;
  price_usd: number;
  max_cores?: number;
}

export const AdminPlansPage = () => {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState(true);

  // Form states
  const [planId, setPlanId] = useState('');
  const [name, setName] = useState('');
  const [tokenQuota, setTokenQuota] = useState<number | string>('');
  const [priceUsd, setPriceUsd] = useState<number | string>('');
  const [maxCores, setMaxCores] = useState<number | string>(1);

  const fetchPlans = () => {
    fetch('https://mec.ericai.online/v1/admin/plans', {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('eric_token')}` }
    })
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) {
          setPlans(data);
        } else {
          console.error("Failed to load plans:", data);
          setPlans([]);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Fetch error:", err);
        setPlans([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  const handleSavePlan = async () => {
    if (!planId || !name || !tokenQuota) return alert('Vui lòng điền đủ thông tin bắt buộc!');
    
    await fetch('https://mec.ericai.online/v1/admin/plans', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('eric_token')}`
      },
      body: JSON.stringify({ 
        id: planId, 
        name, 
        token_quota: Number(tokenQuota), 
        price_usd: Number(priceUsd), 
        max_cores: Number(maxCores) 
      })
    });
    
    // Reset form
    setPlanId(''); setName(''); setTokenQuota(''); setPriceUsd(''); setMaxCores(1);
    fetchPlans();
  };

  const handleDeletePlan = async (id: string) => {
    if (!confirm(`Bạn có chắc chắn muốn xoá gói cước ${id}?`)) return;
    
    const res = await fetch(`https://mec.ericai.online/v1/admin/plans/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('eric_token')}` }
    });
    const result = await res.json();
    if (!result.success) {
      alert('Xoá thất bại: ' + result.error);
    } else {
      fetchPlans();
    }
  };

  const handleEditClick = (p: Plan) => {
    setPlanId(p.id);
    setName(p.name);
    setTokenQuota(p.token_quota);
    setPriceUsd(p.price_usd);
    setMaxCores(p.max_cores || 1);
  };

  if (loading) return <div>Loading plans...</div>;

  return (
    <div className="fade-in">
      <div style={{ marginBottom: '24px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, color: 'var(--text-primary)' }}>Billing Plans</h2>
        <p style={{ color: 'var(--text-secondary)', marginTop: '8px' }}>Manage credit packages</p>
      </div>

      {/* CREATE / UPDATE FORM */}
      <div className="glass-panel" style={{ marginBottom: '24px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>Create / Update Plan</h3>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div style={{ flex: '1 1 150px' }}>
            <label style={{ display: 'block', fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '8px' }}>Plan ID</label>
            <input type="text" value={planId} onChange={e => setPlanId(e.target.value)} placeholder="e.g. pack_1m" style={{ width: '100%', padding: '10px', borderRadius: '6px', background: 'rgba(0,0,0,0.2)', border: '1px solid var(--border)', color: '#fff' }} />
          </div>
          <div style={{ flex: '1 1 150px' }}>
            <label style={{ display: 'block', fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '8px' }}>Name</label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="e.g. 1M Tokens" style={{ width: '100%', padding: '10px', borderRadius: '6px', background: 'rgba(0,0,0,0.2)', border: '1px solid var(--border)', color: '#fff' }} />
          </div>
          <div style={{ flex: '1 1 150px' }}>
            <label style={{ display: 'block', fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '8px' }}>Token Credit</label>
            <input type="number" value={tokenQuota} onChange={e => setTokenQuota(e.target.value)} placeholder="1000000" style={{ width: '100%', padding: '10px', borderRadius: '6px', background: 'rgba(0,0,0,0.2)', border: '1px solid var(--border)', color: '#fff' }} />
          </div>
          <div style={{ flex: '1 1 150px' }}>
            <label style={{ display: 'block', fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '8px' }}>Price (USD)</label>
            <input type="number" value={priceUsd} onChange={e => setPriceUsd(e.target.value)} placeholder="0" style={{ width: '100%', padding: '10px', borderRadius: '6px', background: 'rgba(0,0,0,0.2)', border: '1px solid var(--border)', color: '#fff' }} />
          </div>
          <div style={{ flex: '1 1 150px' }}>
            <label style={{ display: 'block', fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '8px' }}>Max Cores</label>
            <input type="number" value={maxCores} onChange={e => setMaxCores(e.target.value)} placeholder="1" style={{ width: '100%', padding: '10px', borderRadius: '6px', background: 'rgba(0,0,0,0.2)', border: '1px solid var(--border)', color: '#fff' }} />
          </div>
          <button onClick={handleSavePlan} style={{ padding: '10px 24px', borderRadius: '6px', background: 'linear-gradient(135deg, var(--accent-purple), var(--accent-cyan))', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, height: '40px' }}>
            Save Plan
          </button>
        </div>
      </div>

      {/* TABLE */}
      <div className="glass-panel" style={{ padding: '0', overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border)', background: 'rgba(0,0,0,0.2)' }}>
              <th style={{ padding: '16px', fontSize: '12px', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>ID</th>
              <th style={{ padding: '16px', fontSize: '12px', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>NAME</th>
              <th style={{ padding: '16px', fontSize: '12px', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>CREDIT</th>
              <th style={{ padding: '16px', fontSize: '12px', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>PRICE</th>
              <th style={{ padding: '16px', fontSize: '12px', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>CORES</th>
              <th style={{ padding: '16px', fontSize: '12px', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {plans.map(p => (
              <tr key={p.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                <td style={{ padding: '16px', fontWeight: 600, color: 'var(--text-primary)' }}>{p.id}</td>
                <td style={{ padding: '16px', fontWeight: 500, color: 'var(--text-primary)' }}>{p.name}</td>
                <td style={{ padding: '16px', color: 'var(--text-primary)' }}>
                  {Number(p.token_quota).toLocaleString()}
                </td>
                <td style={{ padding: '16px', color: 'var(--text-primary)' }}>
                  ${Number(p.price_usd).toFixed(2)}
                </td>
                <td style={{ padding: '16px', color: 'var(--text-primary)' }}>
                  {p.max_cores || 1}
                </td>
                <td style={{ padding: '16px', display: 'flex', gap: '8px' }}>
                  <button onClick={() => handleEditClick(p)} style={{ padding: '6px 12px', borderRadius: '4px', background: 'var(--bg-glass)', color: 'var(--text-primary)', border: '1px solid var(--border)', cursor: 'pointer', fontSize: '12px', transition: 'var(--transition)' }}>
                    Edit
                  </button>
                  <button onClick={() => handleDeletePlan(p.id)} style={{ padding: '6px 12px', borderRadius: '4px', background: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: '1px solid rgba(239, 68, 68, 0.2)', cursor: 'pointer', fontSize: '12px', transition: 'var(--transition)' }}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
